import { render, staticRenderFns } from "./AddNewReseller.vue?vue&type=template&id=d71f11c2"
import script from "./AddNewReseller.vue?vue&type=script&lang=js"
export * from "./AddNewReseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports